module.exports = __webpack_public_path__ + "img/bg_m.d81ebaa5.jpg";